import React from 'react';
import classnames from 'classnames';
import duperbrowsePaddleStyles from './DuperbrowsePaddles.scss';

export interface Props {
  isEnabled?: boolean;
  className?: string;
  dataHook?: string;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}

export const DuperbrowsePaddle: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  className,
  onClick,
  isEnabled,
  dataHook,
}) => {
  return (
    <div
      className={classnames(
        duperbrowsePaddleStyles['duper'],
        className,
        isEnabled && duperbrowsePaddleStyles['enabled']
      )}
      data-hook={dataHook}
    >
      {isEnabled ? <a onClick={onClick}>{children}</a> : <>{children}</>}
    </div>
  );
};
DuperbrowsePaddle.displayName = 'DuperbrowsePaddle';

export default DuperbrowsePaddle;
